// Insurance
const InsuranceList = () => import('@/views/insurance/InsuranceList.vue')
const InsuranceForm = () => import('@/views/insurance/InsuranceForm.vue')
const InsuranceView = () => import('@/views/insurance/InsuranceView.vue')

export const insuranceRoutes = [
  {
    path: '/patients/:patientId/insurance',
    name: 'PatientInsurance',
    component: InsuranceList,
    meta: {
      requireAuth: true,
      title: 'Patient Insurance'
    }
  },
  {
    path: '/patients/:patientId/insurance/new',
    name: 'NewPatientInsurance',
    component: InsuranceForm,
    meta: {
      requireAuth: true,
      title: 'New Patient Insurance'
    }
  },
  {
    path: '/patients/:patientId/insurance/:id',
    name: 'ViewPatientInsurance',
    component: InsuranceView,
    meta: {
      requireAuth: true,
      title: 'View Patient Insurance'
    }
  },
  {
    path: '/patients/:patientId/insurance/:id/edit',
    name: 'EditPatientInsurance',
    component: InsuranceForm,
    meta: {
      requireAuth: true,
      title: 'Edit Patient Insurance'
    }
  }
]
